import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/Conversations";

export async function GetConversations() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint);
}

export async function UploadData(data) {
  http.addBearerAuthorization();

  var formData = new FormData();
  formData.append("file", data.file);

  return await http.post(apiEndpoint + "/" + data.market_id + "/uploaddata/", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export async function GetConversationDataDetails(marketId) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/details/" + marketId);
}

export async function GetDashboards() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint);
}

export async function GetRegions(marketId) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + marketId + "/regions");
}

export async function GetPostCodes(marketId, region) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + marketId + "/postcodes/" + region);
}

export async function GetIndustries(marketId, region, postcode) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + marketId + "/industries/" + region + "/" + postcode);
}

export async function GetSubIndustries(marketId, region, postcode, industry) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + marketId + "/subindustries/" + region + "/" + postcode + "/" + industry);
}

export async function SyncOfflineData(marketId) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/downloaddata/" + marketId).then(response => {
    if (response.status === 200 && response.data.succeeded) {
      // const dashboardsData = cryptography.encryptAES(JSON.stringify(response.data.data.dashboards));
      // const conversationDataData = cryptography.encryptAES(JSON.stringify(response.data.data.conversationData));
      // const majorRegionsData = cryptography.encryptAES(JSON.stringify(response.data.data.majorRegions));
    }
  });
}

export default {
  GetConversations,
  UploadData,
  GetConversationDataDetails,
  GetDashboards,
  GetRegions,
  GetPostCodes,
  GetIndustries,
  GetSubIndustries,
  SyncOfflineData
};

